export default "__VITE_ASSET__Bkw4pX8v__"